import { type UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getBookingDocumentById } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type QueryPayload = {
  bookingId: ParameterID
  documentId: ParameterID
}

export function useQueryGetBookingDocumentById(
  { bookingId, documentId }: QueryPayload,
  options?: UseQueryOptions
) {
  return useQuery({
    queryKey: [
      'QueryGetBookingDocumentById',
      Number(bookingId),
      Number(documentId),
    ],
    queryFn: async () => await getBookingDocumentById(bookingId, documentId),
    refetchOnWindowFocus: false,
    ...options,
  })
}
